import './LinkedList.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Logger from '@KrashidBuilt/common/utils/logger';
import { SelectField } from '@fifth-gear-tech/common-components/dist/components';

import { get } from '../../api/api';

const logger = new Logger('LinkedList');

class LinkedList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            loading: false,
            lists: [],
            selected: {}
        };
    }

    load = () => {
        const { url, onChange } = this.props;
        this.setState({ loading: true }, async () => {
            try {
                const { selected } = this.state;
                const lists = await get(url, true, selected);

                // values might change or no longer be available based on list selection, so we need to rebuild this object
                const reconstructed = {};

                lists.forEach(({ key, options }) => {
                    const found = options.find((o) => o.value === selected[key]);
                    if (found) {
                        reconstructed[key] = found.value;
                    }
                });

                this.setState({ loaded: true, loading: false, lists, selected: reconstructed }, () => {
                    const { selected } = this.state;
                    onChange(selected);
                });
            } catch (error) {
                logger.error('Unable to process linked lists:', error);
                this.setState({ loading: false, error });
            }
        });
    }

    componentDidMount() {
        const { loaded, loading } = this.state;
        if (!loaded && !loading) {
            this.load();
        }
    }

    onChange = (key, { value }) => {
        const { selected } = this.state;
        this.setState({ selected: Object.assign(selected, { [key]: value }) }, this.load);
    }

    render() {
        logger.extra({ _t: this });
        const { className } = this.props;
        const { lists, selected } = this.state;
        return (
            <div className={`LinkedList ${className}`}>
                {lists.map(({ key, label, options }) => (
                    <div key={key} className={'container'}>
                        <SelectField
                            label={label}
                            noOptionsMessage={({ inputValue }) => `Unable to find ${key} "${inputValue}"`}
                            options={options}
                            value={options.find((o) => o.value === selected[key])}
                            onChange={(value) => {
                                this.onChange(key, value);
                            }}
                        />

                    </div>

                ))}
            </div>
        );
    }
}

LinkedList.defaultProps = {
    className: '',
};

LinkedList.propTypes = {
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    url: PropTypes.string.isRequired,
};

export default LinkedList;